import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { concatMap, Subject } from 'rxjs';
import {
  DROPDOWN_PINS_SETTINGS_KEY,
  DropdownPinPreferences,
  parseDropdownPinPreferences,
} from '../mappers/dropdown-pin-preferences.mapper';
import { UserAppSettingsStore } from './user-app-settings.store';

export const DropdownPinPreferencesStore = signalStore(
  { providedIn: 'root' },
  withState<{ pins: DropdownPinPreferences }>({ pins: {} }),
  withMethods(
    (
      store,
      userAppSettingsStore = inject(UserAppSettingsStore),
      destroyRef = inject(DestroyRef),
    ) => {
      const persist$ = new Subject<void>();
      persist$
        .pipe(
          concatMap(() => {
            const settingsValues = {
              ...(userAppSettingsStore.userAppSettings?.()?.settingsValues ??
                {}),
              [DROPDOWN_PINS_SETTINGS_KEY]: store.pins(),
            };
            return userAppSettingsStore.replaceSettings({ settingsValues });
          }),
          takeUntilDestroyed(destroyRef),
        )
        .subscribe();

      return {
        toggle(pinKey: string, value: string | number): void {
          const current = store.pins()[pinKey] ?? [];
          const next = current.includes(value)
            ? current.filter((item) => item !== value)
            : [value, ...current];
          patchState(store, {
            pins: { ...store.pins(), [pinKey]: next },
          });
          persist$.next();
        },
        hydrateFromBag(
          settingsValues: Record<string, unknown> | undefined,
        ): void {
          patchState(store, {
            pins: parseDropdownPinPreferences(
              settingsValues?.[DROPDOWN_PINS_SETTINGS_KEY],
            ),
          });
        },
      };
    },
  ),
);
